import { IconCalendar, IconChartBar } from '@tabler/icons';


const icons = { IconCalendar, IconChartBar };


const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Calendar',
            type: 'item',
            url: '/',
            icon: icons.IconCalendar,
            breadcrumbs: false
        },
        {
            id: "statistics",
            title: "Statistics",
            type: "item",
            url: "/statistics",
            icon: icons.IconChartBar,
            breadcrumbs: "true",
        }
    ]
};

export default dashboard;
